goog.provide('el8.appchart.dialog.ordermed.rxShared');

goog.require('el8.app.onboarding.activateAccount');
goog.require('el8.appchart.dialog.addRxSig');
goog.require('el8.appchart.dialog.addMedOrderTemplate');
goog.require('el8.appchart.dialog.ordermed.base');
goog.require('el8.appchart.dialog.ordermed.fulfillRx');
goog.require('el8.appchart.dialog.ordermed.util');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.appchart.permissions');
goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.base');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.ordermed');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.base');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.InputFormDialog');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.amplitude.prescriptionFormHelpers');
goog.require('el8.util.consts');


el8.appchart.dialog.ordermed.rxShared = function(dialogType, dialogName) {

    var that = null;
    var container = $('#'+dialogType+'-meds-order-dialog');
    var dialogContainerId = dialogType+'-meds-order-dialog-container';
    var dialog = null;
    var model = null;
    var isMinimized = false;

    // This flag means that we're doing EPCS and the user declined taking ownership of
    // another users draft CS order. We disable eRx and print, etc but allow discarding
    var isReassignCancelled = false;

    // --------------------
    // Get form fields
    // --------------------
    var postDateInputField = container.find(':input[name="postDate"]');
    var medsListSelectField = container.find(':input[name="medsListType"]');

    var rxTypeSelectField = container.find(':input[name="rxType"]');
    var medicationInputField = container.find(':input[name="medication"]');
    var directionsInputField = container.find(':input[name="med-directions"]');
    var quantityInputField = container.find(':input[name="quantity"]');
    var quantityUnitsInputField = container.find(':input[name="quantityUnits"]');
    var authRefillsInputField = container.find(':input[name="authRefills"]');
    var indicationInputField = container.find(':input[name="indication"]');
    var pharmacyInstrInputField = container.find(':input[name="pharmacyInstructions"]');
    var addToPermanentCheckbox = container.find(':input[name="addToPermanentMedList"]');
    var substitutionsCheckbox = container.find(':input[name="substitutions"]');

    var txStartDateInputField = $(':input[name="txStartDate"]', container);
    var oldMedInputField = $(':input[name="oldMedication"]', container);
    var oldDirectionsInputField = $(':input[name="oldDirections"]', container);
    var detailsTrigger = $('#'+dialogType+'-meds-form-details-header', container);

    var addAnotherBtn = $('#'+dialogType+'-meds-form-add-another-btn', container);
    var addToFavoritesBtn = $('#'+dialogType+'-meds-form-add-to-favorites', container);
    var resetBtn = $('#'+dialogType+'-meds-form-reset-btn', container);


    // --------------------
    // Print queue divs
    // --------------------
    var printQueueDiv = $('#'+dialogType+'-meds-form-print-queues', container);
    var formularyDiv = $('.formulary-info', container);

    // -------------------------
    // Initialize the dialog first, because
    // it's needed to initialize the actions menu
    // -------------------------

    function holdFn() {
        // Show the little "minimized" div in the bottom right of the screen
        el8.util.amplitude.logCompletePrescription('minimize', printQueue.length);
        if (el8Globals.FEATURES.MDToolboxEPCS && isReassignCancelled) {
            // Just show the div, don't extract or save as draft
            el8.appchart.mgr.orderForm.renderOnHoldOrder(model);
            hide();
        } else {
            dialog.disableForms();
            model = that.getMedOrder(model, false);
            el8.appchart.mgr.orderForm.renderOnHoldOrder(model);
            if (!that.isEmpty()) {
                save({draft: true});
            }
            dialog.enableForms();
            hide();
        }
    }

    var buttons = {};
    if (el8.appchart.permissions.allow('prescribeMeds')) {
        var currUser = el8.data.currUser;
        var isDelegating = (currUser.isOfficeStaff() || currUser.getRxDelegatingPhysicianIdsInWorkspace().length);

        var eRxPossible = false;
        var draft = false;

        if (!el8Globals.FEATURES.MDToolboxEPCS || !el8.data.currUser.isEpcsEnabled()) {
            eRxPossible = (dialogType !== 'controlled'); // we can't eRx controlled substances yet
        } else {
            // Show the ePrescribe button for CS if the current user has EPCS on and not delegating
            if (dialogType !== 'controlled') {
                eRxPossible = true;
            } else {
                // only hiding ePrescribe button if user is delegated staff
                eRxPossible = !isDelegating ? true : false;

                if (eRxPossible) {
                    draft = true;
                }
            }
        }

        if (el8Globals['FEATURES']['ERx'] && eRxPossible) {
            var ePrescribeText = (isDelegating) ? 'ePrescribe on behalf of physician' : 'ePrescribe';
            buttons[ePrescribeText] = [dialogType+'-meds-order-send-btn', true,
                function() { save({send: true, draft: draft}); }
            ];
            buttons['Print & Close'] = [dialogType+'-meds-order-print-btn', false,
                function() { save({print: true}); }
            ];
        } else {
            var printBtnText = (isDelegating) ? 'Print on behalf of physician' : 'Print & Close';

            buttons[printBtnText] = [dialogType+'-meds-order-print-btn', true,
                function() { save({print: true}); }
            ];
        }
        var signBtnText = (isDelegating) ? 'Sign on behalf of physician' : 'Sign & Close';
        buttons[signBtnText] = [
            dialogType+'-meds-order-save-btn', false,
            function() { save({close: true}); }
        ];
    }
    $.extend(buttons, {
        'Save as Draft & Close' : [
            dialogType+'-meds-order-save-draft-close-btn', false, function() { save({draftClose: true}); }
        ],
        'Discard' : [
            dialogType+'-meds-order-cancel-btn', false, function() { doCancel(); }
        ]
    });

    var dialog = el8.uiwidget.InputFormDialog({
        container: container,
        containerId: dialogContainerId,
        dialogHeight: 530,
        dialogRightMargin: 575-90,
        dialogBottomMargin: 45-30,
        title: '<div class="headerContainer">'+dialogName+' <span class="dialogHeaderNormal">Form</span></div>', // XSS OK -KF
        buttons: buttons,
        closeFn: closeFn,
        disableTitlebarExpand: true,
        makeExpandable: false,
        minimizeFn: function() {
            if( !isMinimized ) {
                holdFn();
                isMinimized = true;
            }
        },
        firstFieldSelector: ':input[name="rxType"]'
    });

    var actionsMenu = new el8.uiwidget.NewActionsMenu({
        container: $('#'+dialogContainerId),
        anchorTop: container,
        menuId: dialogType+'-meds-form-actions-menu',
        offsets: {
            top: 45,
            left: -30
        },
        width: 155
    });

    var reloadVitalsFn = el8.appchart.dialog.ordermed.util.initPatientVitalsPanel(
        $('.meds-form-pt-vitals', container),
        $('.meds-form-pt-vitals fieldset', container)
    );

    // -------------------------
    // Get the base med order form
    // -------------------------
    // closure helper for the event handler below

    // changeFn for the directions/sig infoField defined below. The sig mindreader is
    // populated with the concatenation of sigs returned from Medispan for this specific med
    // and the practice's "favorite" sigs for that Medispan id. Both of those lists are stored
    // (temporarily) on the order med object to be compared with here. This fn fires as the
    // infoField's change handler, it checks if this is a non-medispan sig that we haven't
    // seen yet, and if so, shows the "add new sig" dlg.
    var changeFn = _.bind(function (e) {
        var val = $(e.target).val();

        // Two change events will fire when something is typed in this infofield and then an MR
        // item is clicked: 1. since something is typed then the <input> is blurred and
        // 2. from the MR's setSelectedItem fn. We don't want to pick up the initial event
        // to let the selection from the MR flow into the input, so if the MR is open return
        if (that._mindreaders['directions'].checkIsVisible() &&
            that._mindreaders['directions'].checkIsBeingClicked()) {
            return;
        }

        if (!that._medispanSigs.find(function(sig){ return sig === val; }) &&
            !that._sigs.find(function(sig){ return sig === val; }) &&
            val &&
            val !== 'sig...' &&
            that._medispanSigSourceId &&
            that._medispanSigSourceType) {

            el8.appchart.dialog.addRxSig.show({
                name: that._requiredFields['medication'].getVal(),
                directions:  val,
                sourceId: that._medispanSigSourceId,
                sourceType: that._medispanSigSourceType
            });
        }
    }, that);

    that = new el8.appchart.dialog.ordermed.base({
        container: container,
        printFormType: dialogType,
        medicationField: el8.service.infoField.addInfoField({
                            field : medicationInputField,
                            maxLength : el8.util.consts.MAX_MED_LENGTH,
                            infoText : 'name and strength...'
                        }),
        onMedicationChanged: updateEPrescribeButtonStateFromMed,
        onCustomMedicationChanged: updateEPrescribeButtonStateFromCustomMed,
        directionsField: el8.service.infoField.addInfoField({
                            field : directionsInputField,
                            maxLength : 140,
                            infoText : 'sig...',
                            changeFn: changeFn
                        }),
        indicationField: el8.service.infoField.addInfoField({
                            field : indicationInputField,
                            maxLength : 50,
                            infoText : 'indication...'
                        }),
        quantityField: el8.service.infoField.addInfoField({
                            field : quantityInputField,
                            maxLength : 11,
                            infoText : '#...'
                        }),
        quantityUnitsField: el8.service.infoField.addInfoField({
                            field : quantityUnitsInputField,
                            maxLength : 20,
                            infoText : 'units...'
                        }),
        authRefillsField: el8.service.infoField.addInfoField({
                            field : authRefillsInputField,
                            maxLength : 2,
                            infoText : ''
                        }),
        dxCodesField: $('.dx-codes-list', container),
        startDateField: postDateInputField.el8_datePicker({},
                            { infoText: 'date to fill Rx...' }
                        ),
        txStartDateField: txStartDateInputField.el8_datePicker({},
                            { maxDate : el8.service.tz.today() },
                            { infoText: 'tx start date...' }
                        ),
        oldMedField: el8.service.infoField.addInfoField({
                            field: oldMedInputField,
                            maxLength: 50,
                            infoText: 'previous medication and dose...'
                        }),
        oldDirectionsField: el8.service.infoField.addInfoField({
                            field: oldDirectionsInputField,
                            maxLength: 50,
                            infoText: 'previous medication directions...'
                        }),
        orderTypeSelectField: rxTypeSelectField,
        addToPermanentCheckbox: addToPermanentCheckbox,
        medsListSelectField: medsListSelectField,
        pharmacyInstrField: el8.service.infoField.addInfoField({
                            field : pharmacyInstrInputField,
                            // SS has 210 max and we want to leave 30 for potential Fill Date note.
                            // The controlled print-form doesn't have that much room, though, so we
                            // have to allocate even less for them.
                            maxLength: (dialogType === 'controlled') ? 150 : 180,
                            infoText : 'note to patient and/or pharmacy (e.g., increase from X mg)...'
                        }),
        substitutionsCheckbox: substitutionsCheckbox,
        patientInfoDiv: $('#'+dialogType+'-meds-form-cds', container),
        relatedThreadDiv: $('.meds-related-order', container),
        detailsDiv: $('#'+dialogType+'-meds-form-details', container),
        detailsTrigger: detailsTrigger,
        txStartDateDiv: $('#'+dialogType+'-meds-form-tx-start-date', container),
        oldMedInfoDiv: $('#'+dialogType+'-meds-form-old-med-info', container),
        formularyDiv: formularyDiv,
        isRx: true,
        actionsMenu: actionsMenu
    });
    that.init();

    function closeFn() {
        if (that._userModified && !that.isEmpty()) {
            save({draftClose: true});
        } else {
            that.hide();
            that.reset();
            isMinimized = true;
        }
    }
    that.closeFn = closeFn;


    // ------------------------------
    // Main method to save med order
    // ------------------------------
    function save(opts, callbackFn) {

        opts = opts || {};
        var send = (opts.send === true); // defaults to false
        var print = (opts.print === true); // defaults to false
        var close = (opts.close === true);
        var draft = (opts.draft === true);
        var draftClose = (opts.draftClose === true);
        var addToQueue = send || print || close || (opts.addToQueue === true);

        if (el8Globals.FEATURES.MDToolboxEPCS && isReassignCancelled) {
            _saveReassignCancelled(opts, callbackFn);
            return;
        }

        dialog.disableForms();
        if (that.isEmpty()) {
            if ((send || print || close) && !areQueuesEmpty()) {
                if (send) { doSend(); }
                if (print) { that.doPrint(); }
                if (close) { doSignClose(); }
            } else {
                el8.uiwidget.alert('Please input a medication', null, function() {
                    dialog.enableForms();
                    medicationInputField.focusFocus();
                });
            }
            return;
        }

        // Always do initial save as "draft" because orders only
        // get signed off with "doPrint" or "doERx" or "doSignClose"
        // also check if "send", because now EPCS doesn't sign off MedOrder
        // before sending stuff off to MDToolbox
        model = that.getMedOrder(model, false);
        if (send || (!draft && !draftClose)) {
            //send is true iff this is an ePrescription
            var validated = that.validate(model, send, function() { save(opts, callbackFn); });
            if (!validated.result) {
                if (validated.shouldAlertHTML) {
                    el8.uiwidget.alertHTML(validated.msg);
                } else {
                    el8.uiwidget.alert( validated.msg );
                }
                dialog.enableForms();
                return;
            }
            var validatedCds = that.validateCdsInteractions(model,
                function() {
                    dialog.enableForms();
                    save(opts);
                },  // do again
                function() { dialog.enableForms(); }
            );
            if (!validatedCds ) { return; }
        } else {
            /**
             * Even if we are saving as draft, need to at least have a med saved and a numeric quantity, or else get 500
             */
            var validated = that.validateDraft(model, send);
            if (!validated.result) {
                el8.uiwidget.alert( validated.msg );
                dialog.enableForms();
                return;
            }
        }

        if (draft || draftClose) {
            el8.appservice.notifier.notify(model.getNotifyText('SAVE_IN_PROGRESS'));
        } else {
            el8.appservice.notifier.notify('Adding med to queue');
        }

        var noNotify = send || print || close || false;
        el8.ptdata.medOrders.saveItem(model, noNotify, {async: false});
        if (draft || draftClose) {
            el8.appservice.notifier.notify(model.getNotifyText('SAVE_COMPLETE'));
        } else {
            el8.appservice.notifier.notify('Med added to queue.');
        }

        if (addToQueue) {
            addRxToQueue(model);
            if (that._printFormType !== 'controlled' || !(el8Globals.FEATURES.MDToolboxEPCS && el8.data.currUser.isEpcsEnabled())) {
                // Only reset the UI if the user is not using an EPCS enabled prescription form
                resetUi(addToQueue);
            }
        }
        if (send) {
            doSend();
        } else if (print) {
            that.doPrint('Print & Close');
        } else if (close) {
            doSignClose();
        } else if (draftClose) {
            el8.util.amplitude.logCompletePrescription('Save as Draft & Close', printQueue.length);
            resetUi();
        } else { // draft or addToQueue
            dialog.enableForms();
        }

        if (callbackFn) { callbackFn(); }

    }

        function _saveReassignCancelled (opts, callbackFn) {
        // The user has declined to reassign this CS order to themself, but we still want to allow
        // clicking the close X (draftClose), minimizing (hideFn) and discard.
        //
        // - printing -- adds to print queue and prints -- buttons disabled
        // - queue stuff -- addToQueue will not be passed since UI is locked
        opts = opts || {};

        // Is the form and the queue empty?
        if (that.isEmpty() && areQueuesEmpty()) {
            return;
        }

        // Just hides. Reassign flow will be called again on show
        resetUi();
        return;
    }

    var printQueue;

    // ------------------------------
    // Main methods to take on this form
    // ------------------------------

    // Since the queue might contain both CS and non-CS orders, we may not sign off CS ones
    // if we're doing eRx, since we have to go through MDToolbox first.
    //
    // if forERx is true, it will NOT sign off CS med.
    //
    // Note: the callback is what starts the eRx process for both types
    function signOffQueue(callbackFn, forERx, pharmacy) {
        var addOrder = function(item) {
            el8.appchart.mgr.notes.addNewOrder(item);
        };

        if (!areQueuesEmpty()) {
            var ids = printQueue.map(function(a) { return a['id']; });
            for (var i=0; i<ids.length; i++) {
                var id = ids[i];
                var order = el8.ptdata.medOrders.getById(id);

                var pharmacyState = pharmacy && pharmacy.getState();
                var practiceState = el8.data.currPractice.getState();

                var currentState = (pharmacyState && el8Globals.FEATURES.StateEPCS) ? pharmacyState : practiceState;
                var med = order.getMedication();

                // if we're doing erx, got a controlled substance or state-specified controlled substance,
                // and we have the feature flag on, then we don't sign this med, because we're gonna MDToolbox-it first
                var sign = !(forERx && el8Globals.FEATURES.MDToolboxEPCS && med.isControlled(currentState));

                if (sign) {
                    order.setSignDate(el8.service.tz.now());
                    order.setSignUserId(el8.data.currUser.getId());
                    el8.ptdata.medOrders.saveItem(order, false, {
                        successCb: addOrder,
                        async: false
                    });
                }
            }
            if (callbackFn) { callbackFn(); }
        }
    }
    function cancelQueue(callbackFn) {
        if (!areQueuesEmpty()) {
            el8.appservice.notifier.notify('Discarding queued meds...');
            var ids = printQueue.map(function(a) { return a['id']; });
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('cancelMedOrders'),
                data: {id: ids},
                success: function() {
                    for (var i=0; i<ids.length; i++) {
                        var id = ids[i];
                        var order = el8.ptdata.medOrders.getById(id);
                        el8.ptdata.medOrders.remove(order);
                    }
                    if (callbackFn) { callbackFn(); }
                    el8.appservice.notifier.notify('Queued meds discarded.');
                }
            });
        } else {
            if (callbackFn) { callbackFn(); }
        }
    }

    // Performs ePrescribe and resets UI
    that.doERx = function(pharmacy, serviceLocationId, callbackFn) {
        el8.appservice.notifier.notify('Sending ePrescription(s)...');

        signOffQueue(function() {
            el8.ptdata.medOrders.eRxSet(printQueue, pharmacy, serviceLocationId, function(hide_notification) {
                el8.util.amplitude.logCompletePrescription('ePrescribe Only', printQueue.length);
                resetUi();
                if (!hide_notification) {
                    el8.appservice.notifier.notify('ePrescription sent.');
                }
                if (callbackFn) { callbackFn(); }
            }, false, that._printFormType);
        }, true, pharmacy);
    };

    // Both ePrescribes and prints and resets UI
    that.doERxAndPrint = function(pharmacy, serviceLocationId, callbackFn) {
        el8.appservice.notifier.notify('Sending ePrescription(s) and printing copy...');
        signOffQueue(function() {
            el8.ptdata.medOrders.eRxSet(printQueue, pharmacy, serviceLocationId, function() {
                el8.util.amplitude.logCompletePrescription('ePrescribe & Print Pt Copy', printQueue.length);
                el8.appservice.notifier.notify('ePrescription sent and copy printed.');
                resetUi();
                if (callbackFn) { callbackFn(); }
            }, true, that._printFormType);
        }, true, pharmacy);
    };

    // Performs print and resets UI
    that.doPrint = function(amplitudeSource) {
        el8.appservice.notifier.notify('Printing prescriptions...');
        signOffQueue(function() {
            el8.ptdata.medOrders.printSet(printQueue, function() {
                if (amplitudeSource) {
                    el8.util.amplitude.logCompletePrescription(amplitudeSource, printQueue.length);
                }
                el8.appservice.notifier.notify('Prescriptions printed.');
                resetUi();
            });
        });
    };

    function doSignClose() {
        el8.appservice.notifier.notify('Signing off prescriptions...');
        signOffQueue(function() {
            el8.util.amplitude.logCompletePrescription('Sign & Close', printQueue.length);
            el8.appservice.notifier.notify('Prescriptions signed off and saved.');
            resetUi();
        });
    }

    function doSend() {
        // NOTE: This does not actually sign off the meds; wait for the callback
        // to doERx or doERxAndPrint
        el8.appchart.dialog.ordermed.fulfillRx.show(that);
    }

    function doCancel() {
        dialog.disableForms();
        if (!areQueuesEmpty()) {
            el8.uiwidget.confirm('The active order along with all queued prescriptions will be discarded.  Proceed?',
                function() {
                    cancelQueue(function() {
                        el8.util.amplitude.logCompletePrescription('Discard', printQueue.length);
                        that.deleteActive(false, function() { hide(); });
                    });
                },
                function() {
                    dialog.enableForms();
                }
            );
        } else {
            el8.util.amplitude.logCompletePrescription('Discard', printQueue.length);
            that.deleteActive(false, function() { hide(); });
        }
    }

    that.deleteActive = function(keepQueue, callbackFn, async) {

        var updateUiDelete = function() {
            el8.appservice.notifier.notify( !keepQueue ? 'Prescription is discarded' : 'Form is reset' );
            dialog.enableForms();
            reset(keepQueue);
            if (callbackFn) { callbackFn(); }
        };

        if (model && model.getId() && !model.isSignedOff()) {
            el8.appservice.notifier.notify(model.getNotifyText('DELETE_IN_PROGRESS'));
            el8.ptdata.medOrders.deleteItem(model, false, {
                successCb: function() {
                    updateUiDelete();
                },
                async: async
            });
        } else {
            updateUiDelete();
        }
    };

    // ------------------------------
    // Initialize dialog and buttons
    // ------------------------------
    addAnotherBtn.unbind('click').on('click', function() {
        // If user can't prescribe meds, then save as draft
        save({addToQueue: true, draft: !el8.appchart.permissions.allow('prescribeMeds')}, function() {
            medicationInputField.focusFocus();
        });
    });
    if (that.isEPrescribingControlled()) {
        // The queue is hidden for EPCS, so hide the addAnother button
        addAnotherBtn.hide();
    }
    addToFavoritesBtn.unbind('click').on('click', function() {
        model = that.getMedOrder(model, false);
        var spec = {
            name: medicationInputField.val(),
            infoText: medicationInputField.attr('_infotext') || "",
            directions:  model.getDirections(),
            qty: model.getQuantity(),
            qtyUnits: model.getQuantityUnits(),
            authRefills: model.getAuthRefills(),
            medicationId: model.getMedicationId()
        };
        if (el8.appchart.dialog.addMedOrderTemplate.isPendingUserCreatedMeds(spec)) {
            el8.uiwidget.alert('Please select a known medication ', null, function() {});
        } else if (el8.appchart.dialog.addMedOrderTemplate.isMissingRequiredFields(spec)) {
            el8.uiwidget.alert('Please input a medication', null, function() {});
        } else {
           el8.appchart.dialog.addMedOrderTemplate.show(spec);
        }
    });
    resetBtn.unbind('click').on('click', function() {
        that.deleteActive(true, function() {
            that.initForms();
        });
    });

    function init() {
        dialog.enableForms();
        initQueues();
        container.removeClass('dialogContainer');
    }

    that.enableDialog = function() {
        dialog.enableForms();
        if (that.isEPrescribingControlled()) {
            // The queue is hidden for EPCS. Since we do not clear the form when saving, but push a med to the queue
            // we want to clear the queue when we get return as the form is still filled out.
            clearQueues();
        }
    };

    that.closeIfNoQueue = function() {
        that.deleteActive(true, function() {
            if (areQueuesEmpty()) {
                hide();
            } else {
                that.initForms();
                showSectionRHS('queue');
            }
        });
    };

    // ------------------------------
    // Define "hide" and "show" methods
    // ------------------------------
    function hide() {
        var currUser = el8.data.currUser;
        var isDelegating = (currUser.isOfficeStaff() || currUser.getRxDelegatingPhysicianIdsInWorkspace().length);

        // Reset ICD-10 list editor
        if (that._icd10Listeditor) {
          that._icd10Listeditor.reset();
          that.updateDxCodesError();
        }

        // Reset ePrescribe button
        if (el8.appchart.permissions.allow('prescribeMeds')) {
            if (that._printFormType === 'prescription') {
                var $ePrescribeBtn = $('#prescription-meds-order-send-btn');
                var ePrescribeText = (isDelegating) ? 'ePrescribe on behalf of physician' : 'ePrescribe';
                $ePrescribeBtn.text(ePrescribeText);

                $ePrescribeBtn.unbind('click').on('click', function(){
                    save({send: true, draft: false});
                });
            }
            if (that._printFormType === 'otc') {
                var $sendBtn = $('#otc-meds-order-send-btn');

                var isDelegating = (currUser.isOfficeStaff() || currUser.getRxDelegatingPhysicianIdsInWorkspace().length);
                var ePrescribeText = (isDelegating) ? 'ePrescribe on behalf of physician' : 'ePrescribe';
                $sendBtn.text(ePrescribeText);

                $sendBtn.unbind('click').on('click', function(){
                    save({send: true, draft: false});
                });
            }
        }

        dialog.hide();
    }
    that.hide = hide;

    // 'show' has argument spec when auto refill or dose change requested
    function show( setLastPosition, spec, formType ) {
        // Always reset this
        isReassignCancelled = false;

        // If dialog has not been shown, init the form
        if( !dialog.isVisible() && !isMinimized ) { init(); }

        // Record the show timestamp
        that._createDate = Date.now();
        if (el8Globals['CLOCK_OFFSET_MILLIS']) {
            that._createDate = that._createDate + el8Globals['CLOCK_OFFSET_MILLIS'];
        }

        // For OH only, we need to remind providers to print the positive ID form
        if (el8.data.currPractice.getState().toUpperCase() === 'OH') {
            $('.oh-positive-id-report-reminder', container).show();
        }

        // If we got a spec, populate the model and then, the form
        if (!isMinimized && spec) {

            var newModel = spec.newOrder || spec.model || null;

            if (newModel && (isRxInQueue(newModel) || (model && (model.getId() === newModel.getId()) ))) {
                el8.appservice.notifier.notify('This Rx is already in the form');
                return;
            }

            if ((model && !model.isSignedOff()) || !that.isEmpty()) {

                // If form is already populated, confirm before overwriting
                el8.uiwidget.confirm('Do you want to replace the contents of the active prescription form?',
                    function() {
                        that.deleteActive(true, function() {
                            model = that.updateForm(spec);
                        }, false);
                    });

            // Otherwise, just populate
            } else {
                model = that.updateForm(spec);
            }
        }

        // Show the dialog
        dialog.show( setLastPosition );

        // Needs to be done no matter what
        isMinimized = false;

        // Init the more/less hidden div
        that.initDetailsDiv(
            function() {
                that.adjustHeight();
                pharmacyInstrInputField.focusSelect();
            },
            function() {
                that.adjustHeight();
                if (!model) { // Prevent auto focus if med order is from a draft
                    medicationInputField.focusSelect();
                }
            },
            true
        );

        if (!model) {
            that.initForms();

            // Init with focus on medication field
            medicationInputField.focusSelect();
        }

        that.adjustHeight();

        reloadVitalsFn();

        // Check if the order's prescribing_physician_id is the same
        // as the provider user ID that's trying to open up this draft order
        if (model &&
            el8Globals.FEATURES.MDToolboxEPCS &&
            el8.data.currUser.isEpcsEnabled() &&
            el8.data.currUser.isPhysician() &&
            !model.isByCurrUser() &&
            model.getId() && // want to make sure it's a real DB entry not a fake frontend one (e.g., a new refill from a signed off med)
            model.getMedication() &&
            model.getMedication().isControlled()
        ) {

            var physician_name = model.getPrescribingPhysicianName()
            if (!physician_name) {
                physician_name = 'a staff member without ePrescribing delegate permissions';
            }
            var msg = 'This order was prepared by ' + physician_name +
                '. Would you like to fill this prescription instead?';

            var yesFn = function() {
                // Update in our audit log that prescribing_physician_id was updated to a different id
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('mdtReassignOrder', [model.getId()]),
                    success: function(data) {
                        // Will set the PrescribingPhysician to the current user as physician
                        // (See .extractMedData()), then we'll continue on our merry way...
                        if (data) {
                            save({draft: true});
                            el8.appservice.notifier.notify('Order reassigned');
                        }
                    }
                });
            };
            var noFn = function() {
                // Close the alert dialog, but allow the user to access the dlg for discard, etc.
                // Lock form fields and re-enable print and cancel
                dialog.disableForms();
                var parent = container.parent();
                $('#controlled-meds-order-cancel-btn', parent).prop('disabled', false);

                // Flag for altered save()
                isReassignCancelled = true;
            };
            var opts = {
                yesBtnText: 'Accept & Reassign to me',
                noBtnText: 'Cancel',
                title: 'ALERT'
            };
            el8.uiwidget.confirm(msg, yesFn, noFn, opts);
        }

        var medication = model ? model.getMedication() : null;
        updateEPrescribeButtonStateFromMed(medication, model);
    }
    that.show = show;

    function reset(keepQueue) {
        that.reset();
        model = null;
        isMinimized = false;
        if (!keepQueue) { clearQueues(); }
        dialog.resetForms();
    }

    function resetUi(keepQueue) {
        reset(keepQueue);
        if (keepQueue) {
            that.initForms();
        } else {
            hide();
        }
    }

    // Gets triggered when user somehow selects a custom med or prepopulates custom med.
    //
    // Will only have model when populated when form is being repopulated (i.e. not from the
    // user selecting from the autocomplete). Use this fact to adjust button captions only
    // in the form repopulation case.
    //
    // In that case, if we got filled with a "higher" type of med, change the eRx button to "Switch
    // Forms to ePrescribe"
    function updateEPrescribeButtonStateFromMed(medication, model) {
        if (that._printFormType === 'otc') {
            // Assume that I'm an OTC med in an OTC form
            $('#otc-meds-order-send-btn').prop('disabled', false);

            // Disable button if I'm not an OTC med
            var newFormType = null;
            if (medication && medication.isControlled()) {
                newFormType = 'controlled';
                $('#otc-meds-order-send-btn').prop('disabled', true);
            } else if (medication && medication.isPrescription()) {
                newFormType = 'prescription';
                $('#otc-meds-order-send-btn').prop('disabled', true);
            }

            if (medication && newFormType && model) {
                // If I'm being repopulated with model and I'm of a diff type:
                // change button caption to: "Switch Forms to ePrescribe"
                var $sendBtn = $('#otc-meds-order-send-btn');
                $sendBtn.text('Switch Forms to ePrescribe');
                $sendBtn.prop('disabled', false);

                // Rebind button to switch to form
                $sendBtn.unbind('click').on('click', function(){
                    that.closeIfNoQueue();
                    el8.appchart.mgr.orderForm.showMedsOrderForm(false, {
                        model: model
                    }, newFormType);
                });
            }

        } else if (that._printFormType === 'prescription') {
            // Assume I'm Rx in a Rx form
            $('#prescription-meds-order-send-btn').prop('disabled', false);

            // Disable button if I'm controlled
            if (medication && medication.isControlled()) {
                $('#prescription-meds-order-send-btn').prop('disabled', true);
            }

            // If I'm controlled and being repopulated, show change button
            if (medication && medication.isControlled() && model) {
                var $ePrescribeBtn = $('#prescription-meds-order-send-btn');
                $ePrescribeBtn.text('Switch Forms to ePrescribe');
                $ePrescribeBtn.prop('disabled', false);
                $ePrescribeBtn.unbind('click').on('click', function(){
                    that.closeIfNoQueue();
                    el8.appchart.mgr.orderForm.showMedsOrderForm(false, {
                        model: model
                    }, 'controlled');
                });
            }
        } else if (that._printFormType === 'controlled') {
            if (medication && medication.isControlled() &&
                (medication.isUserCreated() || !el8.data.currUser.isEpcsEnabled())) {
                $('#controlled-meds-order-send-btn').prop('disabled', true);
            } else {
                $('#controlled-meds-order-send-btn').prop('disabled', false);
            }
        }
    }

    // gets triggered when user creatse custom med
    function updateEPrescribeButtonStateFromCustomMed(medication) {
        // not allow eprescription of custom CS meds
        if (medication && medication.medType === 'controlled') {
            $('#controlled-meds-order-send-btn').prop('disabled', true);
        } else {
            $('#controlled-meds-order-send-btn').prop('disabled', false);
        }
    }

    that.minimize = function() {
        dialog.minimize();
    };

    that.setOrderDialogHeight = function() {
        var _height = 450;
        dialog.setDialogHeight(_height+55);
        $('#'+dialogType+'-meds-form', container).height(_height);
    };
    that.adjustHeight = function() {
        clearSizeRHS();
        that.setOrderDialogHeight();
        adjustSizeRHS();
    };

    // ----------------
    // Right hand side - formulary + queue
    // ----------------
    function initRHS() {
        container.on('click', '.meds-form-rhs-section-header',  function(e) {
            $('.meds-form-rhs-section-body', container).each(function(index, elt) {
                if ($(this).is(':hidden')) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
            adjustSizeRHS();
        });
        if (!el8Globals.FEATURES.ERx) {
            container.on('click', '.erx-activate-trigger',  function(e) {
                el8.app.onboarding.activateAccount.show();
                e.preventDefault();
            });
        }
        if (that.isEPrescribingControlled()) {
            // Hide the queue programmatically since it does still appear for non-EPCS users.
            $('#controlled-meds-form-print-queues').hide();
        }
    }
    initRHS();
    function showSectionRHS(type) {
        $('.meds-form-rhs-section-body', container).each(function(index, elt) {
            if ($(this).attr('_type') === type) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        adjustSizeRHS();
    }

    function clearSizeRHS() {
        $('.meds-form-rhs-section-body', container).height(0);
    }
    function adjustSizeRHS() {

        /* Also adjust LHS too */
        var lhsHeight = 0;
        $('.meds-form-lhs-section', container).children().each(function(index, elt) {
            lhsHeight += $(elt).outerHeight(true) || 0;
        });
        $('.meds-form-lhs-section', container).height(lhsHeight);

        // Remove clipping of LHS. Allows for correct MR positioning.
        $('.meds-form-lhs', container).css({'overflow': 'visible'});

        var height = dialog.getDialogHeight() - $('#'+dialogType+'-meds-form-cds', container).outerHeight(true);
        var headerHeight = $('.meds-form-rhs-section-header', container).height();
        $('.meds-form-rhs-section-body', container).each(function(index, elt) {
            if ($(elt).is(':hidden')) {
                $(elt).height(0);
            } else {
                var _height = height - headerHeight - 34;
                var _minHeight = $('.formulary-info', $(elt)).outerHeight(true) || 0;
                if ($(elt).attr('_type') === 'formulary') {
                    if (_minHeight > _height) {
                        $(elt).height(_minHeight);
                        that.setOrderDialogHeight();
                        var altHeight =
                            $(".formulary-alternatives", container).outerHeight(
                                true
                            ) || 0;
                        var altMaxHeight =
                            ($(
                                "#" + dialogType + "-meds-form",
                                container
                            ).outerHeight(true) || 0) -
                            ($(
                                "#" + dialogType + "-meds-form-cds",
                                container
                            ).outerHeight(true) || 0) -
                            (($(
                                "#" + dialogType + "-meds-form-formulary-info",
                                container
                            ).outerHeight(true) || 0) -
                                ($(
                                    ".formulary-alternatives",
                                    container
                                ).outerHeight(true) || 0)) -
                            70;
                        if (altHeight > altMaxHeight) {
                            $(".formulary-alternatives", container).height(
                                altMaxHeight
                            );
                            var heightAgain =
                                dialog.getDialogHeight() -
                                $(
                                    "#" + dialogType + "-meds-form-cds",
                                    container
                                ).outerHeight(true) -
                                headerHeight -
                                34;
                            $(elt).height(heightAgain);
                        }
                    } else {
                        $(elt).height(_height);
                    }
                    var $rhsSection = $('.meds-form-rhs-section', container);
                    var $lhsSection = $('.meds-form-lhs-section', container);
                    if ($lhsSection.height() < ($rhsSection.outerHeight(true) || 0)) {
                        $lhsSection.height(($rhsSection.outerHeight(true) || 0));
                    }
                } else {
                    $(elt).height(_height);
                }
            }
        });
    }

    // ----------------
    // Formulary management
    // ----------------
    var super_lookupFormulary = that.lookupFormulary;
    that.lookupFormulary = function() {
        super_lookupFormulary(function() {
            showSectionRHS('formulary');
        });
    };
    var super_lookupCdsInteractions = that.lookupCdsInteractions;
    that.lookupCdsInteractions = function() {
        super_lookupCdsInteractions(function() {
            showSectionRHS('formulary');
        });
    };

    // ----------------
    // Queue management
    // ----------------
    printQueue = [];

    that.getPrintQueue = function() { return printQueue; };

    function initQueues() {
        $(printQueueDiv).on('click', '.remove-trigger', function(e) {
            var id = $(this).data('id');
            var order = el8.ptdata.medOrders.getById(id);
            el8.ptdata.medOrders.deleteItem(order, false, {
                successCb: function() {
                    removeRxFromQueue(order);
                }
            });
            return false;
        });
    }

    function addRxToQueue(rx) {
        printQueue.push({
            type: dialogType,
            item: rx,
            id: rx.getId()
        });
        renderQueues();
    }

    function removeRxFromQueue(rx) {
        for (var i=0; i<printQueue.length; i++) {
            if (printQueue[i].id === rx.getId()) {
                printQueue.splice(i, 1);
                break;
            }
        }
        renderQueues();
    }

    function renderQueues() {

        if (that.isEPrescribingControlled()) {
            // Since the queue is hidden for EPCS, there is no need to render it.
            return;
        }

        resetDivs();

        if (printQueue.length) {
            $('.meds-form-queue-empty', printQueueDiv).hide();
            showSectionRHS('queue');
        }

        var type = dialogType;
        $('.'+type+'-queue', printQueueDiv).html(
            el8.template.appchart.dialog.ordermed.rxList({
                type: type,
                orders: printQueue.map(function(a) {
                    return {
                        noteSummary: a.item.getNoteSummary(),
                        id: a.item.getId()
                    };
                })
            })
        );
        $('.'+type+'-queue-section', printQueueDiv).show();
        $('.meds-form-queue-count', $('#'+dialogContainerId)).html('<span>'+printQueue.length+'</span>');
    }

    function clearQueues() {
        printQueue = [];
        resetDivs();
        $('.meds-form-queue-count', $('#'+dialogContainerId)).empty();
        $('.meds-form-queue-empty', printQueueDiv).show();
    }

    function resetDivs() {
        $('.'+dialogType+'-queue', printQueueDiv).empty();
        $('.'+dialogType+'-queue-section', printQueueDiv).hide();
    }

    function areQueuesEmpty() {
        return !printQueue.length;
    }

    function isRxInQueue(rx) {
        for (var i=0; i<printQueue.length; i++) {
            if (printQueue[i].id === rx.getId()) {
                return true;
            }
        }
        return false;
    }

    return that;

};
